// extracted by mini-css-extract-plugin
export default {"products":"wt-z","card":"xt-z","oosMessaging":"yt-z"};